import React from 'react';
import { Spinner } from 'react-bootstrap';
import { useTranslate } from 'react-redux-multilingual';

const OverlayTable = ({loading,children}) => {
    const t = useTranslate();

    return(<>
        <div style={{ position: 'relative' }}>
            {/* Overlay extérieur */}
            {loading && (
                <div style={{
                    position: 'absolute',
                    top: 0, left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'rgba(0, 0, 0, 0.2)',
                    zIndex: 2000000,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    pointerEvents: 'auto', // bloque les interactions sous l'overlay
                }}>
                    <Spinner animation="border" />
                    <span style={{ marginLeft: 10 }}>{t('cours_chargement')}...</span>
                </div>
            )}
            {/* Wrapper scroll horizontal */}
            <div>
                   {children} 
            </div>
        </div>
    </>)
}

export default OverlayTable;